// Support Feature Types

export type FeedbackType = 'FEEDBACK' | 'COMPLAINT'

export type FeedbackCategory = 'APP_ISSUE' | 'CONTENT' | 'PAYMENT' | 'TECHNICAL' | 'OTHER'

export type FeedbackPriority = 'LOW' | 'MEDIUM' | 'HIGH'

export type FeedbackStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED'

export interface SubmitFeedbackRequest {
  type: FeedbackType
  category: FeedbackCategory
  priority: FeedbackPriority
  subject: string
  message: string
}

export interface FeedbackResponse {
  id: string
  referenceNumber: string
  userId: string
  type: FeedbackType
  category: FeedbackCategory
  priority: FeedbackPriority
  subject: string
  message: string
  status: FeedbackStatus
  createdAt: string
  updatedAt: string
}

export interface ApiResponseFeedbackResponse {
  success: boolean
  message: string
  timestamp: string
  data: FeedbackResponse
}

// Category labels for UI
export const FEEDBACK_CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  APP_ISSUE: 'App Issue',
  CONTENT: 'Content Issue',
  PAYMENT: 'Payment Issue',
  TECHNICAL: 'Technical Issue',
  OTHER: 'Other',
}

// Priority labels for UI
export const FEEDBACK_PRIORITY_LABELS: Record<FeedbackPriority, string> = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
}
